import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import {
  Autocomplete,
  Card,
  CardHeader,
  Divider,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Button,
  Grid,
  Checkbox,
  CircularProgress,
  CardContent,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormHelperText,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  IconButton,
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  addCompanyService,
  fetchCompanyTypes as fetchCompanyTypesService,
  fetchCurrencies as fetchCurrenciesService,
  fetchIndustries as fetchIndustriesService,
  fetchFrequencies as fetchFrequenciesService,
  fetchCompanyApplications as fetchCompanyApplicationsService,
  fetchSubscriptionPlans as fetchSubscriptionPlansService,
  fetchSingleCompany as fetchSingleCompanyService,
  fetchCompaniesByQuery as fetchCompaniesByQueryService
} from 'services/modules/idp/company';

import { addUserService, fetchRolesService } from "services/modules/idp/user";
import { fetchDimensionsVAPT as fetchDimensionsVAPTService } from 'services/modules/vapt/data';
import { fetchCloudTypes as fetchCloudTypesService } from 'services/modules/vapt/alert';

import { CountryDropdown } from 'react-country-region-selector';
import { useNotification } from 'config/Notification';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { getSOCEnvironment, getSOCGroupValidation } from 'services/modules/soc/agent';


const AddPartnerCompany = () => {

  // Redux dispatch
  const dispatch = useDispatch();

  // Notification
  const { openNotification } = useNotification();

  // State variables
  const steps = ['Add Company', 'Add User', 'View Company'];
  const [activeStep, setActiveStep] = useState(0);
  const [phone, setPhone] = useState("");
  const [nacecode, setNaceCode] = useState("NACE");
  const [countryName, setCountryName] = useState('');
  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const company_id = companyDetails ? companyDetails.id : null;
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [phoneError, setPhoneError] = useState("");
  const [employeeroor, setEmployeerror] = useState("");
  const [emailError, setEmailError] = useState("");
  const [userPhoneError, setUserPhoneError] = useState("")
  const [userEmailError, setUserEmailError] = useState("");
  const [companyErrorMessage, setCompanyErrorMessage] = useState("");
  const [userErrorMessage, setUserErrorMessage] = useState("");
  const [dialog, setDialog] = useState(false);
  const [loading,setLoading] = useState(false);

  const [dynamicFields, setDynamicFields] = useState(['']);
  const [dynamicFieldsNetwork, setDynamicFieldsNetwork] = useState(['']);
  const [socEnvironmentOptions,setSocEnvironmentOptions] = useState([]);

  const location = useLocation();
  const customerType = location.state && location.state.customertype;
  const [formData, setFormData] = useState({
    ppt_report: "false",
    name: '',
    domain: '',
    contactname: '',
    email: '',
    companytype: '',
    country: '',
    location: {
      name: '',
      coords: [0, 0],
    },
    locate: '',
    employesize: '',
    currency: '',
    industry: '',
    subscriptionPlan: '',
    reportFrequency: '',
    applications: [],
    applicationWeightages: [],
    soc_group: '',
    soc_env:'',
    cloudtypes: [],
    category: [],
    webapplications: [],
    network_locations: [],
    mobiletypes: [],
    mobile_code: '91',
    mobile_digits: '',
    partner: '',
    mobile: {
      code: '',
      digits: ''
    },
    heatmap_enable: true,
    supplier_types: ["Insignificant", "Routine", "Preferred", "Strategic"],
    suppliertype_enable: false,
    heatmap: "false",
    supplier_type: '',
  });
  const [userFormData, setUserFormData] = useState({
    uname: '',
    name: '',
    username: '',
    email: '',
    umobile_code: '',
    umobile_digits: '',
    uemail: '',
    mobile: {
      code: '',
      digits: ''
    },
    company: "",
    role: '',
    roles: []
  });

  // Redux selectors
  const industriesContainer = useSelector((state) => state.company.industries);
  const frequenciesContainer = useSelector((state) => state.company.frequencies);
  const currenciesContainer = useSelector(state => state.company.currencies);
  const companyTypesContainer = useSelector(state => state.company.companytypes);
  const authenticatedUserContainer = useSelector(state => state.auth.user);
  const subscriptionsContainer = useSelector(state => state.company.subscriptionPlans);
  const servicesContainer = useSelector(state => state.company.companyapplications);
  const companyNamesContainer = useSelector((state) => state.company.companyNames);
  const hasCreateAnyCompanies = authenticatedUserContainer.roles.some(role => role.permissions.includes('CREATE_ANY_COMPANIES'));
  const rolesContainer = useSelector((state) => state.user.roles);
  const singlecompanyContainer = useSelector((state) => state.company.singleCompany);
  const vaptDimensionsContainer = useSelector(state => state.vaptData.vaptDimensions);
  const cloudTypesContainer = useSelector(state => state.vaptAlert.cloudtypes);


  // useEffect dispatches the actions and updates the store 
  useEffect(() => {
    dispatch(fetchCompanyTypesService());
    dispatch(fetchCurrenciesService());
    dispatch(fetchIndustriesService());
    dispatch(fetchFrequenciesService());
    dispatch(fetchCloudTypesService());
    if (hasCreateAnyCompanies) {
      dispatch(fetchCompanyApplicationsService({}));
      dispatch(fetchSubscriptionPlansService());
      dispatch(fetchCompaniesByQueryService())
      dispatch(fetchDimensionsVAPTService({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect dispatches the fetchRoles service 
  useEffect(() => {
    if (company_id !== undefined && activeStep === 1) {
      dispatch(fetchRolesService({ params: { company: company_id } }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company_id]);

    useEffect(()=>{
       async function fetchData(){
         let response = await getSOCEnvironment();
         setSocEnvironmentOptions(response);
       }
       fetchData();
    },[])

  // useEffect displays supplier type option only if its partner has heatmap enabled
  useEffect(() => {
    if (singlecompanyContainer?.heatmap && singlecompanyContainer?.heatmap === "true" && formData.partner !== '')
      setFormData((formData) => ({
        ...formData,
        suppliertype_enable: true,
      }));
  }, [singlecompanyContainer, formData.partner])

  // This method handles partner company change
  const handleCompanyChange = (event, newValue) => {
    const selectedId = newValue ? newValue.id : '';
    setSelectedCompanyId(selectedId);
    handleInputChange({ target: { name: 'partner', value: selectedId } });
    handlePartnerChange(newValue);

  };

  // This method handles change in autocomplete fields
  const handleAutocompleteChange = (event, newValue) => {
    const selectedId = newValue ? newValue.id : '';
    handleInputChange({ target: { name: 'industry', value: selectedId } });
  };

  // This method displays the services based on partner company change
  const handlePartnerChange = (newPartnerValue) => {
    if (newPartnerValue === '' || newPartnerValue === null) {
      setFormData((prevData) => ({
        ...prevData,
        heatmap_enable: true,
        suppliertype_enable: false,
      }));
      dispatch(fetchCompanyApplicationsService({}));

    }
    else {
      setFormData((prevData) => ({
        ...prevData,
        heatmap_enable: false
      }));
      let companyId = newPartnerValue.id;
      dispatch(fetchSingleCompanyService({ companyId }));
      dispatch(fetchCompanyApplicationsService({ params: { company: companyId } }));

    }
  };

  // This method handles navigation to previous page
  const handleGoBack = () => {
    if (activeStep === 1)
      setDialog(true);
    else
      window.history.back();
  };

  // This method handles changes in user input fields
  const handleUserInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "umobile_digits" && !/^\d+$/.test(value)) {
      setUserPhoneError("Only digits");
    } else {
      setUserPhoneError("");
    }
    if (name === "uemail" && !/^\S+@\S+\.\S+$/.test(value)) {
      setUserEmailError("Invalid email");
    } else {
      setUserEmailError("");
    }
    if (type === 'checkbox' && name === 'applications') {
      setUserFormData((prevFormData) => ({
        ...prevFormData,
        applications: checked
          ? [...prevFormData.applications, value]
          : prevFormData.applications.filter((appId) => appId !== value),
      }));
    }
    else {
      setUserFormData({
        ...userFormData,
        [name]: type === 'checkbox' ? checked : value,
      });
    }
  };

  // This method handles changes in company input fields
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "mobile_digits" && !/^\d+$/.test(value)) {
      setPhoneError("Only digits");
    } else {
      setPhoneError("");
    }
    if (name === "email" && !/^\S+@\S+\.\S+$/.test(value)) {
      setEmailError("Invalid email");
    }
    else {
      setEmailError("");
    }
    if (name === "employesize" && (!/^\d+$/.test(value) || parseInt(value) === 0)) {
      setEmployeerror("Employee size must be a valid number");
    }
    else {
      setEmployeerror("");
    }
    if (type === 'checkbox' && name === 'applications') {
      setFormData((prevFormData) => {
        const updatedApplications = checked
          ? [...prevFormData.applications, value]
          : prevFormData.applications.filter((appId) => appId !== value);
    
        const updatedApplicationWeightages = updatedApplications.map((appId) => ({
          application: appId,
          weightage: 0, // Reset weightage to 0 for all selected applications
        }));
    
        return {
          ...prevFormData,
          applications: updatedApplications,
          applicationWeightages: updatedApplicationWeightages,
        };
      });
    }      
    else if (type === 'checkbox' && name === 'categories') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        category: checked
          ? [...prevFormData.category, value]
          : prevFormData.category.filter((appId) => appId !== value),
      }));
    }
    else if (type === 'checkbox' && name === 'cloudtypes') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cloudtypes: checked
          ? [...prevFormData.cloudtypes, value]
          : prevFormData.cloudtypes.filter((appId) => appId !== value),
      }));
    }
    else {
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
    }


  };

  // This method displays the form error if the form validation is not satisfied
  const handleErrors = (fieldName) => {
    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [fieldName]: true,
    }));
  };

  // This method handles user form submission
  const handleUserSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const updatedFormData = { ...userFormData };
      updatedFormData.name = updatedFormData.uname;
      delete updatedFormData.uname;
      updatedFormData.email = updatedFormData.uemail;
      delete updatedFormData.uemail;
      updatedFormData.mobile = {
        code: phone ? phone : formData.mobile_code,
        digits: userFormData.umobile_digits,
      };
      delete updatedFormData.umobile_digits;
      updatedFormData.roles = [updatedFormData.role];
      delete updatedFormData.role;
      updatedFormData.company = company_id;
      delete updatedFormData.umobile_code;
      const emptyFields = Object.entries(updatedFormData)
        .filter(([name, value]) => value === '')
        .map(([name]) => name);

      if (emptyFields.length > 0) {
        const fieldNames = emptyFields.join(', ');
        setUserErrorMessage(`Please fill in the required fields: ${fieldNames}`);
        return;
      }
      let response = await addUserService(updatedFormData);
      if (response?.status === 200 || response?.status === 201) {
        setUserDetails(response?.data);
        setUserErrorMessage('')
        openNotification('User added successfully', 'success');
        setActiveStep((prevStep) => prevStep + 1);
      }
      else {
        setUserErrorMessage(response?.response?.data?.message);
      }
    }
    catch (error) {

    }
    finally{
      setLoading(false);
    }
  }

  // This method handles company form submission
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.length === 0) {
        openNotification('Atleast one category must be selected', 'error')
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['web-application']) && formData.webapplications.length === 0) {
        openNotification('Please fill the Web Applications field', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['network']) && formData.network_locations.length === 0) {
        openNotification('Please fill the Network Locations field', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['mobile']) && formData.mobiletypes.length === 0) {
        openNotification('Atleast one mobile type must be selected', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['vapt']) && formData.category.includes(categorySlugToIdMap['cloud']) && formData.cloudtypes?.length === 0) {
        openNotification('Atleast one cloud type must be selected', 'error');
        return;
      }
      if (formData.applications.includes(applicationSlugToIdMap['soc']) && formData.soc_group !== ''){
          let response = await getSOCGroupValidation({group:formData.soc_group,soc_env:formData.soc_env});
            if(!response?.data)
              {
               openNotification(response.message,'error');
               return;
              }   
      }
      else{
        delete formData.soc_group;
        delete formData.soc_env
      }
      const updatedFormData = { ...formData };
      updatedFormData.mobile = {
        code: phone ? phone : formData.mobile_code,
        digits: formData.mobile_digits,
      };
      updatedFormData.country = countryName ? countryName : formData.country;
      delete updatedFormData.mobile_code;
      delete updatedFormData.mobile_digits;
      updatedFormData.location = {
        name: updatedFormData.locate,
        coords: [0, 0],
      };
      delete updatedFormData.locate;
      if (!hasCreateAnyCompanies) {
        delete updatedFormData.applications;
        delete updatedFormData.partner;
        delete updatedFormData.subscriptionPlan;
      }
      if (updatedFormData.partner === '')
        delete updatedFormData.partner;
      if (updatedFormData.suppliertype_enable === false)
        delete updatedFormData.supplier_type;
      if (updatedFormData.suppliertype_enable === true)
        delete updatedFormData.heatmap;
      delete updatedFormData.supplier_types;
      delete updatedFormData.heatmap_enable;
      delete updatedFormData.suppliertype_enable;
      if (updatedFormData.heatmap === "false" && formData.partner !== '')
        delete updatedFormData.heatmap;
      if (customerType !== 'Partner')
        delete updatedFormData.heatmap;
      const emptyFields = Object.entries(updatedFormData)
        .filter(([name, value]) => value === '')
        .map(([name]) => name);

      if (emptyFields.length > 0) {
        const fieldNames = emptyFields.join(', ');
        setCompanyErrorMessage(`Please fill in the required fields: ${fieldNames}`);
        return;
      }
      else
        setCompanyErrorMessage('');
      // Check that the sum of weightages equals 100
      const totalWeightage = updatedFormData.applicationWeightages.reduce((sum, weightage) => sum + weightage.weightage, 0);
      if (totalWeightage !== 100) {
        openNotification('The sum of all weightages must equal 100', 'error');
        return;
      }
      updatedFormData.network_locations = formData?.network_locations?.map((app)=>app.trim());
      updatedFormData.webapplications = formData?.webapplications?.map((app)=>app.trim());
      let response = await addCompanyService(updatedFormData);
      if (response?.status === 200 || response?.status === 201) {
        setCompanyDetails(response?.data);
        setCompanyErrorMessage('')
        openNotification('Company added successfully', 'success')
        setActiveStep((prevStep) => prevStep + 1);
      }
      else {
        setCompanyErrorMessage(response);
      }
    }
    catch (error) {
      openNotification('Error while adding the company', 'error');
    }
    finally{
      setLoading(false)
    }
  };


  // Handles adding a new dynamic field for web applications
  const handleAddField = () => {
    setDynamicFields([...dynamicFields, { fieldName: '', }]);
  };

  // Handles adding a new dynamic field for network
  const handleAddFieldNetwork = () => {
    setDynamicFieldsNetwork([...dynamicFieldsNetwork, { fieldName: '', }]);
  };

  // Handles changing a dynamic field for webapplications
  const handleDynamicFieldChange = (index, value) => {
    const updatedFields = [...dynamicFields];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      webapplications: updatedFields
    }));
    setDynamicFields(updatedFields);
  };

  // Handles changing a dynamic field for network
  const handleDynamicFieldChangeNetwork = (index, value) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields[index] = value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      network_locations: updatedFields
    }));
    setDynamicFieldsNetwork(updatedFields);
  };

  // Handles removing a dynamic field for web applications
  const handleRemoveField = (index) => {
    const updatedFields = [...dynamicFields];
    updatedFields.splice(index, 1);
    setDynamicFields(updatedFields);
    setFormData((prevFormData) => ({
      ...prevFormData,
      webapplications: updatedFields
    }))
  };

  // Handles removing a dynamic field for Network
  const handleRemoveFieldNetwork = (index) => {
    const updatedFields = [...dynamicFieldsNetwork];
    updatedFields.splice(index, 1);
    setDynamicFieldsNetwork(updatedFields);
    setFormData((prevFormData) => ({
      ...prevFormData,
      network_locations: updatedFields
    }))
  };

  // Handle the changes for mobiletypes
  const handleMobileTypesChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      mobiletypes: checked
        ? [...prevFormData.mobiletypes, value]
        : prevFormData.mobiletypes.filter((type) => type !== value),
    }));
  }
  const createSlugToIdMap = (items, idKey = '_id') => {
    return items?.reduce((map, item) => {
      map[item.slug] = item[idKey];
      return map;
    }, {});
  };

  const handleWeightageInputChange = (event, appId) => {
    const { value } = event.target;

    // Ensure the value is a number and doesn't exceed 100
    if (!isNaN(value) && value >= 0 && value <= 100) {
      // Update the formData state
      setFormData((prevFormData) => {
        const updatedApplicationWeightages = prevFormData.applicationWeightages.map(weightage =>
          weightage.application === appId
            ? { ...weightage, weightage: Number(value) }
            : weightage
        );

        // If the application was not found, add a new entry
        if (!updatedApplicationWeightages.find(weightage => weightage.application === appId)) {
          updatedApplicationWeightages.push({ application: appId, weightage: Number(value) });
        }
        

        return {
          ...prevFormData,
          applicationWeightages: updatedApplicationWeightages,
        };
      });
    }
  };

  const categorySlugToIdMap = createSlugToIdMap(vaptDimensionsContainer);
  const applicationSlugToIdMap = createSlugToIdMap(servicesContainer, 'id');

  return (
        <div className="position-relative">
      {loading && (
        <div className="card-loader-overlay">
          <CircularProgress size={60} />
        </div>
      )}
    <div className="main-cont">
      <Card className="card">
        <CardHeader
          title={
            <React.Fragment>
              <div className='card-head'>
                <div className="deflex-head">
                  <img src="/assets/partners.svg" alt="icon" className="card-icon" />
                  <label className='label'>
                    {customerType === 'Partner' ? 'Partners' : 'End Customer'}
                    <ArrowRightIcon className='header-size' /> Add new
                  </label>
                </div>
                <div>
                  <Button variant="contained" className="back font" onClick={handleGoBack}>Back</Button>
                </div>
              </div>
            </React.Fragment>
          }
        />
        <Divider className="stepper-divider" />
        <Card>
          <div>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
          <Divider className="divider" />
          <CardContent className="center-card">
            {activeStep === 0 && (
              <Card className=" user-card row company-screen-bg">
                <div className="row col-lg-12">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="name"
                        label="Company Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('name')}
                        error={formData.name === '' && formErrors.name}
                        helperText={formData.name === '' && formErrors.name ? 'Field is required' : ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="domain"
                        label="Domain URL"
                        value={formData.domain}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('domain')}
                        error={formData.domain === '' && formErrors.domain}
                        helperText={formData.domain === '' && formErrors.domain ? 'Field is required' : ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="contactname"
                        label="Contact Name"
                        value={formData.contactname}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('contactname')}
                        error={formData.contactname === '' && formErrors.contactname}
                        helperText={formData.contactname === '' && formErrors.contactname ? 'Field is required' : ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md flex">
                    <Grid item >
                      <PhoneInput
                        fullWidth
                        className="tellphone pos"
                        country={"india"}
                        enableSearch={true}
                        value={phone ? phone : formData.mobile_code}
                        onChange={(country) => setPhone(country)}
                      />
                    </Grid>
                    <TextField
                      variant="outlined"
                      label="Phone"
                      fullWidth name="mobile_digits"
                      value={formData.mobile_digits}
                      onChange={handleInputChange}
                      onBlur={() => handleErrors('mobile_digits')}
                      error={(formData.mobile_digits === '' && formErrors.mobile_digits) || !!phoneError}
                      helperText={(formData.mobile_digits === '' && formErrors.mobile_digits) ? 'Field is required' : phoneError || ''}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined" label="Email"
                        fullWidth name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('email')}
                        error={(formData.email === '' && formErrors.email) || !!emailError}
                        helperText={(formData.email === '' && formErrors.email) ? 'Field is required' : emailError || ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth
                      onBlur={() => handleErrors('companytype')}
                      error={formData.companytype === '' && formErrors.companytype}>
                      <InputLabel htmlFor="companytype">Company type</InputLabel>
                      <Select
                        name="companytype"
                        value={formData.companytype}
                        onChange={handleInputChange}
                        label="Company Type"
                      >
                        <MenuItem value="">
                        </MenuItem>
                        {companyTypesContainer?.data?.map((type) => (
                          <MenuItem key={type.id} value={type.id}>
                            {type.companytype}
                          </MenuItem>
                        ))}
                      </Select>
                      {formData.companytype === '' && formErrors.companytype && (
                        <FormHelperText>Field is required</FormHelperText>
                      )}
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                    <FormControl fullWidth>
                      <CountryDropdown
                        value={countryName === '' ? formData?.country : countryName}
                        onChange={(value) => setCountryName(value)}
                        className="country-dropdown company-screen-bg"
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl style={{ width: '100%' }}>
                      <TextField fullWidth
                        variant="outlined" label="Location"
                        name="locate" value={formData.locate}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('locate')}
                        error={formData.locate === '' && formErrors.locate}
                        helperText={formData.locate === '' && formErrors.locate ? 'Field is required' : ''} />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth
                      onBlur={() => handleErrors('currency')}
                      error={formData.currency === '' && formErrors.currency}>
                      <InputLabel htmlFor="Currency">Currency</InputLabel>
                      <Select
                        name="currency"
                        value={formData.currency}
                        onChange={handleInputChange}
                        label="Currency"
                      >
                        <MenuItem value="">
                        </MenuItem>
                        {currenciesContainer?.data?.map((currency) => (
                          <MenuItem key={currency.id} value={currency.id}>
                            {`${currency.Code}-${currency.Currency}`}
                          </MenuItem>
                        ))}
                      </Select>
                      {formData.currency === '' && formErrors.currency && (
                        <FormHelperText>Field is required</FormHelperText>
                      )}
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        label="No.of Employees"
                        fullWidth name="employesize"
                        value={formData.employesize} onChange={handleInputChange}
                        onBlur={() => handleErrors('employesize')}
                        error={(formData.employesize === '' && formErrors.employesize) || !!employeeroor}
                        helperText={(formData.employesize === '' && formErrors.employesize) ? 'Field is required' : employeeroor || ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth>
                      <Autocomplete
                        options={industriesContainer?.data}
                        getOptionLabel={(option) => option?.label || ''}
                        value={industriesContainer?.data?.find((option) => option.id === formData.industry) || null}
                        onChange={handleAutocompleteChange}
                        renderInput={(params) => (
                          <TextField {...params} label="Industry" variant="outlined"
                            onBlur={() => handleErrors('industry')}
                            error={formData.industry === '' && formErrors.industry}
                            helperText={formData.industry === '' && formErrors.industry ? 'Field is required' : ''} />
                        )}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 pa-md " >
                    <FormControl fullWidth>
                      <InputLabel htmlFor="nace"> Standard</InputLabel>
                      <Select
                        name="nace"
                        value={nacecode}
                        onChange={() => setNaceCode('NACE')}
                        label="Standard"
                      >
                        <MenuItem value="NACE">
                          NACE
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {companyNamesContainer.results && customerType === 'Partner' && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md">
                      <FormControl fullWidth>
                        <Autocomplete
                          options={companyNamesContainer.results || []}
                          getOptionLabel={(option) => option.name || ''}
                          value={companyNamesContainer.results.find((company) => company.id === selectedCompanyId) || null}
                          onChange={handleCompanyChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Partner Company"
                              variant="outlined"
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                  )}
                  {formData.suppliertype_enable && customerType === 'Partner' && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                      <FormControl fullWidth>
                        <InputLabel htmlFor="supplier_type">Supplier type</InputLabel>
                        <Select
                          name="supplier_type"
                          value={formData.supplier_type}
                          onChange={handleInputChange}
                          label="Supplier Type"
                        >
                          {formData.supplier_types.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                  )}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                  </div>
                  {frequenciesContainer && (
                    <div className="report-frequency">
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-primary">Report frequency</FormLabel>
                        <RadioGroup
                          row
                          name="reportFrequency"
                          value={formData.reportFrequency}
                          onChange={handleInputChange}
                        >
                          {frequenciesContainer.map((frequency) => (
                            <FormControlLabel
                              key={frequency.id}
                              value={frequency.id}
                              control={<Radio />}
                              label={frequency.label}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  )}
                  {(
                    <div className="report-frequency">
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-primary">Subscription plan</FormLabel>
                        <RadioGroup
                          row
                          name="subscriptionPlan"
                          value={formData.subscriptionPlan}
                          onChange={handleInputChange}
                        >
                          {subscriptionsContainer.map((subscription) => {
                            if (customerType === 'Partner' && formData.partner === '') {
                              if (subscription.label !== 'Basic') {
                                return (
                                  <FormControlLabel
                                    key={subscription.id}
                                    value={subscription.id}
                                    control={<Radio />}
                                    label={subscription.label}
                                  />
                                );
                              }
                            } else if (subscription.label === 'Basic') {
                              return (
                                <FormControlLabel
                                  key={subscription.id}
                                  value={subscription.id}
                                  control={<Radio />}
                                  label={subscription.label}
                                />
                              );
                            }
                            return null;
                          })}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  )}
                  {(
                    <div className="report-frequency">
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-primary">Services</FormLabel>
                        <FormGroup row>
                          {servicesContainer?.map((application) => (
                            <FormControlLabel
                              key={application.id}
                              control={
                                <Checkbox
                                  checked={formData.applications.includes(application.id)}
                                  onChange={handleInputChange}
                                  name="applications"
                                  value={application.id}
                                />
                              }
                              label={application.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </div>
                  )}
                  {formData?.applications && formData?.applications.length > 0 && (<div className="report-frequency">
                    <FormControl component="fieldset">
                      <FormLabel component="legend" className="text-primary">Selected Services Weightage</FormLabel>
                      <FormGroup row>
                        {servicesContainer && servicesContainer.map((application) => {
                          // Find the weightage for the current application
                          const weightageObj = formData.applicationWeightages.find(weightage => weightage.application === application.id);
                          const weightageValue = weightageObj ? weightageObj.weightage : 0;

                          return formData.applications.includes(application.id) && (
                            <span key={application.id} style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                              <span>{application.label}</span>
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                style={{ width: '60px', marginLeft: '10px' }}
                                value={weightageValue} // Set the value from the weightage object
                                onChange={(e) => handleWeightageInputChange(e, application.id)} // Assuming you have a function to handle changes
                                placeholder="Weightage" // Placeholder for better UX
                              />
                            </span>
                          );
                        })}
                      </FormGroup>
                    </FormControl>
                  </div>)}
                  {servicesContainer.some(application => (
                    (application.label === 'SOC') &&
                    formData.applications.includes(application.id)
                  )) &&
                    (
                      <div className='row  mt-3'>
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4 p-0 pt-2">
                        <FormLabel component="legend" className='text-primary'>
                            SOC Group
                          </FormLabel>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 p-0">
                          <FormControl fullWidth>
                            <TextField
                              variant="outlined"
                              label="SOC Group"
                              size='small'
                              fullWidth
                              name="soc_group"
                              value={formData.soc_group}
                              onChange={handleInputChange}

                            />
                          </FormControl>
                        </div>
                          
                     

                      </div>
                    )
                  }

          {servicesContainer.some(application => (
                    (application.label === 'SOC') &&
                    formData.applications.includes(application.id)
                  )) &&
                    (
                      <div className='row  mt-3'>
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-4 p-0 pt-2">
                        <FormLabel component="legend" className='text-primary'>
                            SOC Environment
                          </FormLabel>
                          </div>
                          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 p-0">
                          <FormControl fullWidth>
                        <InputLabel htmlFor="soc_env">SOC Environment</InputLabel>
                        <Select
                          name="soc_env"
                          value={formData.soc_env}
                          onChange={handleInputChange}
                          label="SOC Environment"
                          size='small'
                        >
                          {socEnvironmentOptions.map((type) => (
                            <MenuItem key={type.id} value={type.name}>
                              {type.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                        </div>
                      </div>
                    )
                  }

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md "></div>
                  {servicesContainer.some(application => (
                    (application.label === 'ECS') &&
                    formData.applications.includes(application.id)
                  ))
                    &&
                    (
                      <div className="report-frequency">
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-primary">PPT report generation</FormLabel>
                          <RadioGroup
                            row
                            name="ppt_report"
                            value={formData.ppt_report}
                            onChange={handleInputChange}
                          >
                            <FormControlLabel value="true" control={<Radio />} label="Yes" />
                            <FormControlLabel value="false" control={<Radio />} label="No" />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    )}
                  {formData.heatmap_enable && customerType === 'Partner'
                    && servicesContainer.some(application => ((application.label === 'ECS' || application.label === 'RHYMSCAN') &&
                      formData.applications.includes(application.id)))
                    && (
                      <div className="report-frequency">
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-primary">Heatmap</FormLabel>
                          <RadioGroup
                            row
                            name="heatmap"
                            value={formData.heatmap}
                            onChange={handleInputChange}
                          >
                            <FormControlLabel value="true" control={<Radio />} label="Yes" />
                            <FormControlLabel value="false" control={<Radio />} label="No" />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    )}

                  {servicesContainer.some(application => (
                    (application.label === 'VAPT') &&
                    formData.applications.includes(application.id)
                  )) &&
                    (
                      <div className="report-frequency">
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-primary">Categories</FormLabel>
                          <FormGroup row>
                            {vaptDimensionsContainer && vaptDimensionsContainer.map((maindim) => (
                              <FormControlLabel
                                key={maindim._id}
                                control={
                                  <Checkbox
                                    checked={formData.category.includes(maindim._id)}
                                    onChange={handleInputChange}
                                    name="categories"
                                    value={maindim._id}
                                  />
                                }
                                label={maindim.label}
                              />
                            ))}
                          </FormGroup>
                        </FormControl>
                      </div>
                    )}


                  {
                    <div className='report-frequency'>
                      <div className='row'>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                          <FormLabel component="legend" className='text-primary'>
                            Web Applications
                          </FormLabel>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <Button sx={{ color: 'blue' }} onClick={handleAddField}>Add</Button>
                        </div>
                      </div>

                      {dynamicFields.map((field, index) => (
                        <div className='row' key={index}>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                            <TextField
                              fullWidth
                              size='small'
                              label="Web Application"
                              name='webapplications'
                              onChange={(e) => handleDynamicFieldChange(index, e.target.value)}
                            />
                          </div>
                          <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                            <IconButton onClick={() => handleRemoveField(index)}>
                              <DeleteIcon sx={{ color: 'red' }} />
                            </IconButton>
                          </div>
                        </div>
                      ))}
                    </div>
                  }

                  {
                    <div className='report-frequency'>
                      <div className='row'>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-0">
                          <FormLabel component="legend" className='text-primary' >
                            Network Locations
                          </FormLabel>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <Button sx={{ color: 'blue' }} onClick={handleAddFieldNetwork}>Add</Button>
                        </div>
                      </div>
                      {dynamicFieldsNetwork.map((field, index) => (
                        <div className='row'>
                          <div key={index} className="col-lg-4 col-md-6 col-sm-12 col-xs-12  p-0">
                            <TextField
                              fullWidth
                              size='small'
                              label="Network"
                              name='Network'
                              onChange={(e) => handleDynamicFieldChangeNetwork(index, e.target.value)}
                            />
                          </div>
                          <div className='col-lg-1 col-md-3 col-sm-6 col-xs-6'>
                            <IconButton onClick={() => handleRemoveFieldNetwork(index)}>
                              <DeleteIcon sx={{ color: 'red' }} />
                            </IconButton>
                          </div>
                        </div>
                      ))}
                    </div>
                  }

                  {
                    <div className="report-frequency">
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-primary">Mobile Types</FormLabel>
                        <FormGroup row>
                          <FormControlLabel
                            key='Android'
                            control={
                              <Checkbox
                                checked={formData.mobiletypes.includes('Android')}
                                onChange={handleMobileTypesChange}
                                name="Android"
                                value="Android"
                              />
                            }
                            label="Android"
                          />
                          <FormControlLabel
                            key='IOS'
                            control={
                              <Checkbox
                                checked={formData.mobiletypes.includes('IOS')}
                                onChange={handleMobileTypesChange}
                                name="IOS"
                                value="IOS"
                              />
                            }
                            label="IOS"
                          />
                        </FormGroup>
                      </FormControl>
                    </div>
                  }
                  {(
                    <div className="report-frequency">
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className="text-primary">Cloud Services</FormLabel>
                        <FormGroup row>
                          {cloudTypesContainer?.map((type) => (
                            <FormControlLabel
                              key={type?.id}
                              control={
                                <Checkbox
                                  checked={formData?.cloudtypes?.includes(type.id)}
                                  onChange={handleInputChange}
                                  name="cloudtypes"
                                  value={type.id}
                                />
                              }
                              label={type.label}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </div>
                  )}
                  <p className="error-message">{companyErrorMessage}</p>
                </div>
              </Card>
            )}
            {activeStep === 1 && (
              <Card className="user-card row company-screen-bg">
                <div className="row col-lg-12">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="uname"
                        label="Name"
                        value={userFormData.uname}
                        onChange={handleUserInputChange}
                        onBlur={() => handleErrors('uname')}
                        error={userFormData.uname === '' && formErrors.uname}
                        helperText={userFormData.uname === '' && formErrors.uname ? 'Field is required' : ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="username"
                        label="User Name"
                        value={userFormData.username}
                        onChange={handleUserInputChange}
                        onBlur={() => handleErrors('username')}
                        error={userFormData.username === '' && formErrors.username}
                        helperText={userFormData.username === '' && formErrors.username ? 'Field is required' : ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md flex">
                    <Grid item>
                      <PhoneInput
                        fullWidth
                        className="tellphone pos"
                        country={"india"}
                        enableSearch={true}
                        value={phone ? phone : formData.mobile_code}
                        onChange={(country) => setPhone(country)}
                      />
                    </Grid>
                    <TextField
                      variant="outlined"
                      label="Phone"
                      fullWidth name="umobile_digits"
                      value={userFormData.umobile_digits}
                      onChange={handleUserInputChange}
                      onBlur={() => handleErrors('umobile_digits')}
                      error={(userFormData.umobile_digits === '' && formErrors.umobile_digits) || !!userPhoneError}
                      helperText={(userFormData.umobile_digits === '' && formErrors.umobile_digits) ? 'Field is required' : userPhoneError || ''}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth name="uemail"
                        label="Email ID"
                        value={userFormData.uemail}
                        onChange={handleUserInputChange}
                        onBlur={() => handleErrors('uemail')}
                        error={(userFormData.uemail === '' && formErrors.uemail) || !!userEmailError}
                        helperText={userFormData.uemail === '' && formErrors.uemail ? 'Field is required' : userEmailError || ''}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md ">
                    <FormControl fullWidth>
                      <TextField
                        variant="outlined"
                        fullWidth name="name"
                        label="Company Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        onBlur={() => handleErrors('name')}
                        error={formData.name === '' && formErrors.name}
                        helperText={formData.name === '' && formErrors.name ? 'Field is required' : ''}
                        InputProps={{
                          disabled: true,
                        }}
                      />
                    </FormControl>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 pa-md "></div>
                  {rolesContainer.data && (
                    <div>
                      {rolesContainer.data.some((role) => role.label === 'Admin') ? (
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className="text-primary">Role</FormLabel>
                          <RadioGroup
                            row
                            name="role"
                            value={userFormData.role}
                            onChange={handleUserInputChange}
                          >
                            {rolesContainer.data
                              .filter((role) => role.label === 'Admin')
                              .map((role) => (
                                <FormControlLabel
                                  key={role.id}
                                  value={role.id}
                                  control={<Radio />}
                                  label={role.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      ) : (
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Role</FormLabel>
                          <RadioGroup
                            row
                            name="role"
                            value={userFormData.role}
                            onChange={handleUserInputChange}
                          >
                            {rolesContainer.data
                              .filter((role) => role.label !== 'Admin')
                              .map((role) => (
                                <FormControlLabel
                                  key={role.id}
                                  value={role.id}
                                  control={<Radio />}
                                  label={role.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      )}
                    </div>
                  )}
                </div>
                <p className="error-message">{userErrorMessage}</p>
              </Card>
            )}
            {activeStep === 2 && (
              <Card className="row company-screen-bg">
                <div className="row col-lg-12" style={{ justifyContent: 'center' }}>

                  <div className="form-container ">
                    <div>
                      <img src="/assets/tickmark.png" alt="img" className="card-icon" />
                    </div>
                    <br />
                    <div>
                      <label>You have successfully created company and user</label>
                    </div>
                    <div>
                      <span>{new Date(companyDetails?.createdAt).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })}</span>
                    </div>
                    <div>An email with temporary password has been sent to <b>{userFormData.uemail}</b></div><br />
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                      {companyDetails && (
                        <div id="companyInfo" className="text-body-1 text-grey-7">
                          <p><strong>Company name:</strong> {companyDetails.name}</p>
                          <p><strong>Location:</strong> {companyDetails.location.name}</p>
                          <p><strong>Email:</strong> {companyDetails.email}</p>
                          <p><strong>Phone:</strong> +{companyDetails.mobile?.code} {companyDetails.mobile?.digits}</p>
                          <p><strong>Industry:</strong> {companyDetails.industry?.label}</p>
                          <p><strong>Domain URL:</strong> {companyDetails.domain}</p>
                          <p><strong>Subscription plan:</strong> {companyDetails.subscriptionPlan?.label}</p>

                          <p>
                            <strong>Applications:</strong>

                            {companyDetails.applications?.map((app, index) => (
                              <span key={app.id}>
                                {app.label}
                                {index < companyDetails.applications.length - 1 && ','}
                              </span>
                            ))}
                          </p>
                        </div>
                      )}

                    </div>
                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                      {userDetails && (
                        <div id="companyInfo" className="text-body-1 text-grey-7">
                          <p><strong>Name:</strong> {userDetails?.name}</p>
                          <p><strong>User name:</strong> {userDetails?.username} </p>
                          <p><strong>Email id:</strong> {userDetails?.email}</p>
                          <p><strong>Role:</strong> {userDetails.roles[0].label}</p>
                          <p><strong>Mobile no:</strong> {userDetails.mobile?.digits}</p>
                          <p><strong>Location:</strong> {companyDetails.location.name}</p>
                        </div>
                      )}
                    </div>
                  </div>


                </div>
              </Card>
            )}
          </CardContent>
          {activeStep < steps.length - 1 && activeStep === 0 && (
            <div className="center-card radio-card">
              <Button variant="contained" onClick={(e) => handleSubmit(e)}>
                CONTINUE
              </Button>
            </div>
          )}
          {activeStep === 1 && (
            <div className="center-card radio-card">

              <Button variant="contained" onClick={(e) => handleUserSubmit(e)}>
                CONTINUE
              </Button>
            </div>
          )}
          {activeStep === 2 && (
            <div className="radio-card center-card">

              <Button variant="contained" onClick={() => window.history.back()}>
                FINISH
              </Button>
            </div>
          )}
          <Dialog open={dialog} onClose={() => setDialog(false)} aria-labelledby="delete-dialog-title">
            <DialogTitle align="center">
              <ErrorOutlineIcon fontSize="large" color="error" />
            </DialogTitle>
            <DialogContent align="center">
              Are you sure you want to go back without adding user?
            </DialogContent>
            <DialogActions className="m-3">
              <Button onClick={() => setDialog(false)} variant="contained" className="btn-card">
                No
              </Button>
              <Button onClick={() => window.history.back()} variant="contained" className="btn-card danger">
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </Card>
    </div>
    </div>
  );
}

export default AddPartnerCompany;

